<form [formGroup]="formGroup">

  <div class="row">
    <div [class.col-12]="!inline" [class.col-9]="inline">
      <label class="form-label">{{ placeholder }}</label>
    </div>

    <div
      [class.col-4]="inline"
      [class.col-6]="!inline"
    >
      <app-form-group
        name=""
        class="w-100"
        [formControl]="formGroup.controls.min"
        type="number"
        placeholder="Min."
        [small]="small"
      ></app-form-group>

    </div>

    <div
      [class.col-5]="inline"
      [class.col-6]="!inline"
    >
      <app-form-group
        name=""
        class="w-100"
        [formControl]="formGroup.controls.max"
        type="number"
        placeholder="Max."
        [small]="small"
      ></app-form-group>
    </div>

  </div>
</form>
